export const PREMIUM_FEATURES = [
  'Unlimited web-based Attack Box & Kali',
  'Full access to learning paths',
  'Faster Machines',
  'Access to networks',
  'Private OpenVPN Servers',
  'Private King of the Hill games',
] as const;
